var React = require('react');

function FeatureStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.04826 1.45158C9.34625 0.527435 10.6538 0.527435 10.9517 1.45158L12.8328 7.28522H18.9412C19.9081 7.28522 20.3121 8.52095 19.5319 9.0921L14.5836 12.7148L16.4696 18.5639C16.7672 19.4865 15.7094 20.2503 14.9272 19.6776L10 16.0704L5.07282 19.6776C4.2906 20.2503 3.23285 19.4865 3.53036 18.5639L5.41641 12.7148L0.468072 9.0921C-0.31208 8.52095 0.091912 7.28522 1.05879 7.28522H7.16718L9.04826 1.45158Z","fill":"#FFEE55"}));
}

FeatureStar.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = FeatureStar;

FeatureStar.default = FeatureStar;
